export const legacyTimeline = [
  {
    year: "2007",
    title: "The Journey Begins",
    description:
      "The journey begins around building a knowledge and communication platform for the textile and apparel industry.",
  },
  {
    year: "2008",
    title: "Amin & Jahan Corporation Established",
    description:
      "Amin & Jahan Corporation is established. Textile Today develops as a major industry media and knowledge platform.",
  },
  {
    year: "2010s",
    title: "Expansion & Diversification",
    description:
      "Expansion into research, publications, training, events and industry engagement across multiple touchpoints.",
  },
  {
    year: "2020s",
    title: "Innovation & Transformation",
    description:
      "Expansion toward innovation, capability development and practical industry transformation through Textile Today Innovation Hub.",
  },
  {
    year: "Today",
    title: "Integrated Ecosystem",
    description:
      "A&J operates a broader ecosystem spanning research, media, training, consultancy, events, industry promotion and innovation.",
  },
];